<div class="toolbar" [class.handset]="handsetService.isHandset">
  <app-toolbar (mainNotificationHeightChange)="onMainNotificationResize($event)"></app-toolbar>
</div>

<mat-sidenav-container
  (swipeleft)="onSwipeLeft()"
  [ngStyle]="containerStyle"
  (swiperight)="onSwipeRight($event)"
  [class.toolbar-banner]="showToolbarBanner()"
  ngClass.xs="xs"
>
  <mat-sidenav
    #drawer
    [disableClose]="!handsetService.isHandset"
    (closedStart)="toolbarService.changeIconAfterClosing()"
    [fixedInViewport]="true"
    [fixedTopGap]="handsetService.isHandset ? 0 : showToolbarBanner() ? 130 : 64"
    [mode]="handsetService.isHandset ? 'over' : 'side'"
    [opened]="!handsetService.isHandset"
    [autoFocus]="false"
    class="sidenav"
    ngClass.xs="xs">
    <app-sidenav [drawer]="drawer" (clickEvent)="onSidenavClick()"></app-sidenav>
    <div style="flex: 1; padding-bottom: 8px;" fxLayout="row" fxLayoutAlign="space-around end">

      <button mat-menu-item routerLink="/settings" [matTooltip]="'Ustawienia'" style="width: 48px; text-align: center;
       border-radius: 24px; text-overflow: unset;">
        <app-icon name="settings" [height]="18" [width]="18"></app-icon>
      </button>
      <button mat-menu-item [matTooltip]="'Pomoc'" style="width: 48px;
      text-align: center; border-radius: 24px; text-overflow: unset;">
        <a href="https://payka.pl/pytania-i-odpowiedzi/" target="_blank">
          <app-icon name="contact_support" [height]="18" [width]="18"></app-icon>
        </a>
      </button>
      <button
        aria-label="Wyloguj"
        mat-menu-item (click)="logout()" [matTooltip]="'Wyloguj'" style="width: 48px; text-align: center;
      border-radius: 24px; text-overflow: unset;">
        <app-icon name="power_settings" [height]="18" [width]="18"></app-icon>
      </button>

    </div>
  </mat-sidenav>

  <mat-sidenav-content class="banner-wrapper">
    <!--    <app-banner></app-banner>-->
  </mat-sidenav-content>
  <mat-sidenav-content class="sidenav-content"
                       [ngClass]="{'red-border': showRedBorder, 'handset': handsetService.isMobile}">
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
